import Field, { Input } from "../../ui/Field";
import a from "./auth.module.css";

export default function AuthField({
  label,
  hint,
  type = "text",
  value,
  onChange,
  placeholder,
  name,
  autoComplete,
  required,
  minLength,
}) {
  return (
    <Field label={label} hint={hint}>
      <Input
        className={a.authInput}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        required={required}
        minLength={minLength}
      />
    </Field>
  );
}
